import { MoonIcon } from '@chakra-ui/icons';
import './HeaderNavs.css'
import {
    Box,
    Center,
    Container,
    Flex,
    Heading,
    Circle,
    HStack,
    IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState } from 'react';
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import Navbar from './Navbar';

const Header = () => {
    const [dark, setDark] = useState(false);
    useEffect(() => {
        if (dark) {
            document.documentElement.classList.add("dark");
        } else {
            document.documentElement.classList.remove("dark");
        }
    }, [dark])
    return (
        <Box as="header" my={3} p={1}
            className="sticky top-0 z-40 bg-zinc-50 dark:bg-zinc-900 ">
            <Container maxW={"container.lg"} className="relative ring-2 dark:ring-lime-300 ring-blue-300 py-2 shadow-md rounded-md">
                {/* <Circle
                    className="absolute  -bottom-2 right-40"
                    onClick={() => {
                        setSmall(!small);
                    }}>
                    <IoIosArrowDropdown className="text-xl" />
                </Circle> */}
                <Flex gap={4} justify="space-between">
                    <Center>
                        <Heading
                            as="a"
                            href="/"
                            id="logo"
                            size="lg"
                            className="text-zinc-900 dark:text-stone-300 truncate name1 "
                        >
                            MD Rifat Nime
                        </Heading>
                    </Center>

                    <Navbar />

                    <HStack>
                        <IconButton
                            as={"a"}
                            target={"_blank"}
                            rel="noreferrer"
                            href="https://github.com/RifatNime"
                            size={"sm"}
                            icon={<AiFillGithub />}
                            className="hover: bg-blue-400 dark:bg-lime-400 shadow hover:shadow-md font-bold rounded-full dark:bg-gray-700 dark:text-bg-lime-50"
                        ></IconButton>
                        <IconButton
                            as={"a"}
                            rel="noreferrer"
                            href="https://www.linkedin.com/in/rifat-naeem-8012881b9/"
                            size={"sm"}
                            icon={<AiFillLinkedin />}
                            className="hover: bg-blue-400 dark:bg-lime-400 shadow hover:shadow-md font-bold rounded-full dark:bg-gray-700 dark:text-bg-lime-50"
                        ></IconButton>
                        <IconButton
                            onClick={() => {
                                setDark(!dark);
                            }}
                            size={"sm"}
                            icon={<MoonIcon />}
                            className="hover: bg-blue-400 dark:bg-lime-400 shadow hover:shadow-md font-bold rounded-full dark:bg-black dark:bg-gray-700 dark:text-bg-lime-50"
                        ></IconButton>
                    </HStack>
                </Flex>
            </Container>
            {/* {small && (
        <Container maxW={"container.lg"}>
          <Center gap={4} justify="space-between">
            {small && <Nav small={small} />}
          </Center>
        </Container>
      )} */}
        </Box >
    );
};

export default Header;